import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'
import googleTagManager from '@analytics/google-tag-manager'
import { environment } from './config/environment'

export const analytics = Analytics({
    app: 'gonet',
    plugins: [
        googleAnalytics({
            measurementIds: [environment.GOOGLE_ANALYTICS.GOOGLE_ANALYTICS_ID]
        }),
        googleTagManager({
            containerId: environment.GOOGLE_ANALYTICS.GOOGLE_TAG_MANAGER_ID
        })
    ]
})